import Complement from "../composition/Complement"

export default class Reflector extends Complement {
    static className = "Reflector"
}